module.exports = __webpack_public_path__ + "media/images/logos/fc-erzgebirge-3ec76c98921098e8862369df7407116d.png";